import React from 'react';

type AuthScreenProps = {
    children: React.ReactNode;
    cardWidth?: number;
};

const AuthScreen: React.FC<AuthScreenProps> = ({ children, cardWidth = 340 }) => (
    <div style={styles.wrapper}>
        <div style={{ ...styles.card, width: cardWidth }}>{children}</div>
    </div>
);

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f2ec',
        fontFamily: "'DM Mono',monospace",
    },
    card: {
        background: 'white',
        borderRadius: 16,
        padding: '40px 36px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.10)',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
    },
};

export default AuthScreen;
